import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

import {PricePlanAlertsService} from "../../services/price-plan-alerts.service";
import {PricePlanService} from "../../services/price-plan-service.service";
import {ContractPriceType} from "../../../contracts/types/contract-price.type";
import {PriceType} from "../../types/price.type";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class ProgramDeliveryAmountViewCtrl implements IController {
  programId: string;
  priceType: any;
  accountId: string;

  public programData: any;
  public minCommissionValue: any;
  public commissionPercentage: any;
  public isSaveAvailable: boolean;
  public currencySymbol: string;
  public isEditable: boolean;
  public programTypesMap: any;
  public isCommissionByCurrency: boolean;

  constructor(private PricePlanService: PricePlanService, private confirmDialogService: ConfirmDialogService,
              private pricePlanAlertsService: PricePlanAlertsService, private splitService) {
    this.programTypesMap = _.merge(ContractPriceType, PriceType)
    this.currencySymbol = splitService.getCurrencySymbol();
  }

  $onInit() {
    this._getProgramData();
  }

  onChange() {
    this._onDataChange();
  }


  onEdit() {
    this.isEditable = true
    if (!_.isNumber(this.commissionPercentage.value)) {
      this.isCommissionByCurrency = true;
      this._onDataChange();
    }
  }

  onSaveProgram(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {

        this.PricePlanService.saveProgramDataByGroups(this.programId, this.programData, ['Pricing'], this.accountId)
          .then((programData) => {
            this.programData = programData;
            this.commissionPercentage = _.find(programData.data[0].value, (v) => {
              return v.id === "CommissionPercentage"
            });
            this.minCommissionValue = _.find(programData.data[0].value, (v) => {
              return v.id === "MinCommissionValue"
            });
            this.isCommissionByCurrency = _.isUndefined(this.minCommissionValue.value);
            this.isSaveAvailable = false;
          })
          .finally(() => {
            this.isEditable = false;
          })
      }
    }
  }

  changeCommissionByCurrency(byCurrency) {
    this.isCommissionByCurrency = byCurrency;
    if (byCurrency) {
      _.unset(this.commissionPercentage, 'value');
    } else {
      this.minCommissionValue.value = 0;
    }
    this.onChange();
  }

  onCancelChanges(){
    this._getProgramData();
  }

  private _getProgramData() {
    this.PricePlanService.getProgramPreferencesByGroups(this.programId, ['Pricing'], this.accountId)
      .then((programData) => {
        this.programData = programData;
        this.commissionPercentage = _.find(programData.data[0].value, (v) => {
          return v.id === "CommissionPercentage"
        });
        this.minCommissionValue = _.find(programData.data[0].value, (v) => {
          return v.id === "MinCommissionValue"
        });
        this.isCommissionByCurrency = _.isUndefined(this.minCommissionValue.value);
      })
  }


  private _onDataChange(value?) {
    this.isSaveAvailable = _.isUndefined(value) ? true : value;
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('programDeliveryAmountView', {
    bindings: {
      programId: '<',
      priceType: '<',
      accountId: '<?'
    },
    template: require('./program-delivery-amount-view.html').default,
    controller: ProgramDeliveryAmountViewCtrl
  });

